import React from "react";

// 10 branded poster cards — each pre-styled with number badge + title/subtitle baked in.
const POSES = [
  {
    n: "01",
    title: "Flex & Connect",
    img: "https://customer-assets.emergentagent.com/job_swolemates-2/artifacts/o849eiff_6A933DC4-C8B6-4076-AD4A-399B69EBB6B4.jpg",
  },
  {
    n: "02",
    title: "Post-Workout Vibes",
    img: "https://customer-assets.emergentagent.com/job_swolemates-2/artifacts/4xujve6q_6A933DC4-C8B6-4076-AD4A-399B69EBB6B4_1.jpg",
  },
  {
    n: "03",
    title: "Team Every Rep",
    img: "https://customer-assets.emergentagent.com/job_swolemates-2/artifacts/ybnjzjs0_6A933DC4-C8B6-4076-AD4A-399B69EBB6B4_2.jpg",
  },
  {
    n: "04",
    title: "Laugh. Lift. Love.",
    img: "https://customer-assets.emergentagent.com/job_swolemates-2/artifacts/s5gge8es_6A933DC4-C8B6-4076-AD4A-399B69EBB6B4_3.jpg",
  },
  {
    n: "05",
    title: "High Five, Higher You",
    img: "https://customer-assets.emergentagent.com/job_swolemates-2/artifacts/t4hrgecv_6A933DC4-C8B6-4076-AD4A-399B69EBB6B4_4.jpg",
  },
  {
    n: "06",
    title: "Built Side by Side",
    img: "https://customer-assets.emergentagent.com/job_swolemates-2/artifacts/dgda6lcj_6A933DC4-C8B6-4076-AD4A-399B69EBB6B4_5.jpg",
  },
  {
    n: "07",
    title: "Back to Back",
    img: "https://customer-assets.emergentagent.com/job_swolemates-2/artifacts/cx6kdopk_6A933DC4-C8B6-4076-AD4A-399B69EBB6B4_6.jpg",
  },
  {
    n: "08",
    title: "Partners in Progress",
    img: "https://customer-assets.emergentagent.com/job_swolemates-2/artifacts/nns86ynu_6A933DC4-C8B6-4076-AD4A-399B69EBB6B4_7.jpg",
  },
  {
    n: "09",
    title: "Love Is Our Motivation",
    img: "https://customer-assets.emergentagent.com/job_swolemates-2/artifacts/erdktuer_6A933DC4-C8B6-4076-AD4A-399B69EBB6B4_9.jpg",
  },
  {
    n: "10",
    title: "Next Workout, Next Date",
    img: "https://customer-assets.emergentagent.com/job_swolemates-2/artifacts/2sjrwu9i_6A933DC4-C8B6-4076-AD4A-399B69EBB6B4_8.jpg",
  },
];

const CouplePoses = () => {
  return (
    <section
      id="couple-poses"
      data-testid="couple-poses-section"
      className="relative py-24 md:py-32 bg-[#0A0A0A]"
    >
      <div className="container mx-auto max-w-7xl px-6 md:px-10">
        <div className="max-w-3xl mb-14 md:mb-20">
          <p className="text-xs uppercase tracking-[0.3em] text-[#C6FF00] font-semibold mb-4">
            The Look
          </p>
          <h2 className="font-heading text-5xl md:text-6xl lg:text-7xl text-white leading-[0.95]">
            Couple Poses.
            <br />
            <span className="text-[#C6FF00]">Real Moments.</span>
          </h2>
          <p className="mt-6 text-base text-neutral-400 max-w-xl">
            Ten prompts. From a first flex to a tenth date — show up, show off,
            and turn workouts into your favorite memories.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5">
          {POSES.map((p, i) => (
            <div
              key={p.n}
              data-testid={`pose-card-${i}`}
              className="group relative aspect-[4/5] rounded-2xl overflow-hidden border border-white/5 hover:border-[#C6FF00]/40 transition-all duration-500"
            >
              <img
                src={p.img}
                alt={p.title}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-contain transition-transform duration-700 group-hover:scale-105"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CouplePoses;
